import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=25950b9c&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=25950b9c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25950b9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25950b9c')) {
      api.createRecord('25950b9c', component.options)
    } else {
      api.reload('25950b9c', component.options)
    }
    module.hot.accept("./PaymentMethod.vue?vue&type=template&id=25950b9c&scoped=true", function () {
      api.rerender('25950b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Billing/Components/PaymentMethod.vue"
export default component.exports